/************************************
MODULE:         DROPDOWN WITH LINKS SELECTION
WHAT IT DOES:   Dropdown that redirects you to a corresponding page when selected
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function init() {
        var storeselect = $('.js-selectlist');
        if (!storeselect.length)
            return;

        storeselect.on('change', selectItem)
    }

    function selectItem() {
        var selectedUrl = $(this).val();
        if (selectedUrl)
            window.location.href = selectedUrl;
    }


    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.selectlist.js
 ** module id = 55
 ** module chunks = 24
 **/